module.exports = __webpack_public_path__ + "static/media/DSC_0083.45af0f38.jpg";